'use client';
import {useTranslations} from 'next-intl';
import {useState} from 'react';
import {useBaseMutation} from '@/libs/api/baseRequests';
import {hideDeleteModal} from '@/libs/jquery.util';
import {DELETE_PRODUCT_REVIEW_REPLY_QUERY, EDIT_PRODUCT_REVIEW_REPLY_QUERY} from '@/graphql/mutations';
import {useUserContext} from '@/providers/UserContext';


export default function ProductReviewRepliesEditDelete({ currentReply, setReplies, setNewRepliesObj, replyIndex, reviewIndex, openDeleteModal }) {
  const t = useTranslations('product');
  
  const { user } = useUserContext();
  const [isEditingReply, setEditingReply] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [isReplySubmitting, setReplySubmitting] = useState(false);
  
  const { mutate: deleteReply } = useBaseMutation(DELETE_PRODUCT_REVIEW_REPLY_QUERY, {
    toastOnComplete: { toast: true, message: t('replyDeleted') }
  });
  const { mutate: editReply } = useBaseMutation(EDIT_PRODUCT_REVIEW_REPLY_QUERY, {
    toastOnComplete: { toast: true, message: t('replyEdited') }
  });
  
  const handleReplyChange = (e) => {
    setReplyText(e.target.value);
  };
  
  const onReplyEditClick = (idx, reply) => {
    setReplyText(reply.comment);
    setEditingReply(true);
  }
  
  const onReplyEditCancel = () => {
    setEditingReply(false);
    setReplyText('');
  }
  
  const onReplyEdit = async () => {
    setReplySubmitting(true);
    const result = await editReply({
      variables: {
        id: currentReply.id,
        comment: replyText,
      }
    });
    if (result.data) {
      if (typeof setReplies === 'function') {
        setReplies(prev => prev.map((reply, idx) =>
            idx === replyIndex
                ? { ...reply, comment: replyText }
                : reply
        ));
      } else {
        setNewRepliesObj(prevState => ({
          ...prevState,
          [reviewIndex]: prevState[reviewIndex]?.map((reply, idx) => {
            return idx === replyIndex ? { ...reply, comment: replyText } : reply;
          })
        }));
      }
      onReplyEditCancel();
    }
    setReplySubmitting(false);
  };
  
  const onReplyDeleteClick = (idx, id) => {
    openDeleteModal('reply', (setDeleting) => onReplyDelete(idx, id, setDeleting));
  }
  
  const onReplyDelete = async (idx, id, setDeleting) => {
    setDeleting(true);
    const result = await deleteReply({
      variables: {
        id
      }
    });
    if (result.data) {
      if (typeof setReplies === 'function') {
        setReplies(prev => [
          ...prev.slice(0, idx),
          ...prev.slice(idx + 1)
        ]);
      } else {
        setNewRepliesObj(prevState => ({
          ...prevState,
          [reviewIndex]: prevState[reviewIndex]?.filter((reply, ind) => ind !== replyIndex)
        }));
      }
      
    }
    hideDeleteModal();
    setDeleting(false);
  }
  
  return (
      <>
        {
          isEditingReply ? (
              <div className="reply-comment-field">
                <textarea
                    name="reply-comment"
                    placeholder={t('editReply')}
                    value={replyText}
                    disabled={isReplySubmitting}
                    onChange={handleReplyChange}
                />
                <button
                    className="btn theme-btn-3 btn-effect-1 text-uppercase"
                    disabled={isReplySubmitting}
                    onClick={onReplyEditCancel}
                >
                  {t('cancel')}
                </button>
                <button
                    className="btn theme-btn-1 btn-effect-1 text-uppercase"
                    type="submit"
                    disabled={isReplySubmitting}
                    onClick={onReplyEdit}
                >
                  {isReplySubmitting ? t('submitting') : t('submit')}
                </button>
              </div>
          ) : (
              <>
                <p>{currentReply.comment}</p>
                {
                  currentReply.client.email === user?.email ? (
                      <>
                        <button
                            className="btn btn-transparent reply-button me-2 float-none"
                            onClick={() => onReplyDeleteClick(replyIndex, currentReply.id)}
                            data-bs-toggle="modal"
                            data-bs-target="#delete-base-modal"
                        >
                          <i className="fas fa-trash me-2"></i>
                          {t('delete').toUpperCase()}
                        </button>
                        <button
                            className="btn btn-transparent reply-button float-none"
                            onClick={() => onReplyEditClick(replyIndex, currentReply)}
                        >
                          <i className="fas fa-edit me-2"></i>
                          {t('edit').toUpperCase()}
                        </button>
                      </>
                  ) : ''
                }
              </>
          )
        }
      </>
  );
}
